import { MAKKAH_CONTACTS } from '@/config/eclipse'
import { useEclipsePhase } from '@/hooks/useEclipsePhase'
import { useI18n } from '@/i18n'
import { cn } from '@/lib/cn'

/** Live text describing which stage of the eclipse we are in. */
export function PhaseStatus({ className }: { className?: string }) {
  const { t } = useI18n()
  const phase = useEclipsePhase(MAKKAH_CONTACTS)

  const label = {
    before: t.countdown.statusBefore,
    partial: t.countdown.statusPartial,
    totality: t.countdown.statusTotality,
    after: t.countdown.statusAfter,
  }[phase]

  const isLive = phase === 'totality'

  return (
    <p
      aria-live="polite"
      className={cn(
        'flex items-center justify-center gap-2.5 text-[0.6875rem] uppercase tracking-[0.24em] sm:text-xs',
        isLive ? 'text-ember' : 'text-muted',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'inline-block h-1.5 w-1.5 rounded-full',
          isLive ? 'animate-pulse bg-ember' : 'bg-gold/60',
        )}
      />
      {label}
    </p>
  )
}
